import { render, staticRenderFns } from "./mai_doc.vue?vue&type=template&id=774f8fb2&scoped=true"
import script from "./mai_doc.vue?vue&type=script&lang=js"
export * from "./mai_doc.vue?vue&type=script&lang=js"
import style0 from "./mai_doc.vue?vue&type=style&index=0&id=774f8fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774f8fb2",
  null
  
)

export default component.exports